/**
 * Qué tan completo está el perfil: cinco puntos de 20 % cada uno. Es una
 * función pura; la app Flutter tiene la misma (`lib/core/perfil_completo.dart`)
 * con los mismos casos de prueba.
 *
 * 1. nombre    — `name_user` con algo además de espacios.
 * 2. correo    — `opc_email_verified`.
 * 3. whatsapp  — `opc_whatsapp_verified`.
 * 4. foto      — `path_photo_url` (la misma llave que pinta el avatar).
 * 5. respaldo  — una segunda forma de entrar: contraseña + al menos una cuenta
 *                vinculada (Google, Apple, Facebook), o dos cuentas vinculadas.
 *                Sale de `GET /auth/social/identities`; si no se pudo leer
 *                (`null`: 404, error de red) el punto cuenta como pendiente,
 *                sin mostrar error.
 */

export type PuntoPerfil = 'nombre' | 'correo' | 'whatsapp' | 'foto' | 'respaldo';

/** En este orden se listan los pendientes. */
export const PUNTOS_PERFIL: readonly PuntoPerfil[] = ['nombre', 'correo', 'whatsapp', 'foto', 'respaldo'];

export interface DatosPerfilCompleto {
    name_user?: string | null;
    opc_email_verified?: boolean | null;
    opc_whatsapp_verified?: boolean | null;
    path_photo_url?: string | null;
}

export interface FormasParaPerfil {
    opc_has_password: boolean;
    identities: { cod_provider: string }[];
}

export interface PerfilCompleto {
    /** 0, 20, 40, 60, 80 o 100. */
    porcentaje: number;
    pendientes: PuntoPerfil[];
}

/** Punto 5: si pierde una forma de entrar, le queda otra. */
export function tieneRespaldo(formas: FormasParaPerfil | null | undefined): boolean {
    if (!formas) return false;
    const proveedores = new Set(
        (formas.identities ?? []).map((i) => i?.cod_provider).filter((p): p is string => !!p),
    );
    if (formas.opc_has_password === true) return proveedores.size >= 1;
    return proveedores.size >= 2;
}

export function perfilCompleto(
    datos: DatosPerfilCompleto | null | undefined,
    formas: FormasParaPerfil | null | undefined,
): PerfilCompleto {
    const cumple: Record<PuntoPerfil, boolean> = {
        nombre: !!datos?.name_user?.trim(),
        correo: datos?.opc_email_verified === true,
        whatsapp: datos?.opc_whatsapp_verified === true,
        foto: !!datos?.path_photo_url?.trim(),
        respaldo: tieneRespaldo(formas),
    };
    const pendientes = PUNTOS_PERFIL.filter((p) => !cumple[p]);
    return { porcentaje: (PUNTOS_PERFIL.length - pendientes.length) * 20, pendientes };
}
